module.exports = __webpack_public_path__ + "static/enemies-a-love-story-acf54a91e97faf2de42b97c87734bfac.jpg";